// src/Rotas.jsx
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./pages/home/index.jsx";
import Login from "./pages/login/index.jsx";
import PrivateRoute from "./services/private.jsx";

import DashBoard from "./pages/dashboard/receive-payments/index.jsx";
import Videos from "./pages/youtube/index.jsx";
// import SideBar from "./components/sidebar/index.jsx"; // NÃO precisamos importar mais aqui
import MainFinancas from "./pages/main-financas/main-financas.jsx";
import DashBoardVendas from "./pages/dashboard/Vendas/index.jsx";
import RelatorioVendasDetalhamento from "./pages/dashboard/VendasDetalhamento/index.jsx";
import MovimentacaoCaixa from "./pages/movimentacao/movimentacao/index.jsx";
import MovimentacaoCaixaAnalitico from "./pages/movimentacao/movimentacao/mov-analitico/index.jsx";
import ProdutosDeletados from "./pages/movimentacao/deletados/index.jsx";
import AlterarVendaContainer from "./pages/movimentacao/alterar-venda/index.jsx";
import ListContaEntradaSZ from "./components/table/ce/indexSZ.jsx";
import ModulosVideos from "./pages/youtube/modulos/index.jsx";
import Teste from "./pages/teste/teste.jsx";
import { RegisterClientProvider } from "./components/register/register-cliente/context/index.jsx";
import { MainRegisterClient } from "./pages/register/register-cliente/index.jsx";
import { ProviderGlobal } from "./context/index.jsx";
import { MainRegisterColaborador } from "./pages/register/register-colaborador/index.jsx";
import { RegisterCollaboratorProvider } from "./components/register/register-colaborador/context/index.jsx";
import { RegisterSupplierProvider } from "./components/register/register-fornecedor/context/index.jsx";
import { MainRegisterFornecedor } from "./pages/register/register-fornecedor/index.jsx";
import ReportSaleBySeller from "./pages/dashboard/vendas-colaborador/index.jsx";
import { RegisterProductProvider } from "./pages/register/product/context/index.jsx";
import MainRegisterProduct from "./pages/register/product/main/index.jsx";
import MainRegisterComplements from "./pages/register/complements/main/index.jsx";
import MainRegisterStore from "./pages/register/store/main/index.jsx";
import MainRegisterDeliveryFee from "./pages/register/delivery-fee/main/index.jsx";
import MainRegisterStoreHours from "./pages/register/store-hours/main/index.jsx";
import MainRegisterScheduledPauses from "./pages/register/scheduled-pauses/main/index.jsx";
import MainRegisterFormPayment from "./pages/register/form-payment/main/index.jsx";
import FormRegisterNewStore from "./pages/contratacao/register-contracting-start/index.jsx";
import DownLoadDemo from "./pages/contratacao/downloads/pdv/index.jsx";
import MainRegisterCostCenter from "./pages/register/cost-center/main/index.jsx";
import MainRemessaBoleto from "./pages/boleto/remessa/index.jsx";
import MainRetornoBoleto from "./pages/boleto/retorno/index.jsx";
import MainRegisterBoletoConfig from "./pages/register/boleto-config/main/index.jsx";
import MainRegisterFiscalConfig from "./pages/register/fiscal-config/main/index.jsx";
import MainRegisterTypeAccount from "./pages/register/type-account/main/index.jsx";
import MainRegisterClientType from "./pages/register/client-type/main/index.jsx";
import MainRegisterCollaboratorType from "./pages/register/collaborator-type/main/index.jsx";
import MainRegisterBank from "./pages/register/bank/main/index.jsx";
import MainRegisterCategory from "./pages/register/product-category/main/index.jsx";
import ReportCurvaABC from "./pages/report/product/abc/index.jsx";
import ReportEstoqueBaixo from "./pages/report/product/estoque-baixo/index.jsx";
import ReportItemFaturamento from "./pages/report/venda-item/venda-faturamento.jsx";
import ReportsProductsSoldAndInventory from "./pages/report/product/vendas-estoque/index.jsx";
import ReportGradeVendidos from "./pages/report/product/grade-vendidos/index.jsx";
import ReportEstoqueBaixoGrade from "./pages/report/product/estoque-baixo-grade/index.jsx";
import ReportListagemVendas from "./pages/report/venda/listagem/index.jsx";
import ReportNotaFiscal from "./pages/fiscal/listagem/index.jsx";
import MonitorFiscal from "./pages/fiscal/monitor/index.jsx";
import DocumentosFiscais from "./pages/fiscal/documentos/index.jsx";
import FechamentoFiscal from "./pages/fiscal/fechamento/index.jsx";
import NotasSefaz from "./pages/fiscal/sefaz/index.jsx";
import MainRegisterAccountOut from "./pages/register/account-out/main/index.jsx";
import MainRegisterAccountEntry from "./pages/register/account-entry/main/index.jsx";
import PasswordRecovery from "./components/login/recovery/index.jsx";
import Forgot from "./components/login/forgot/index.jsx";
import MainRegisterBanner from "./pages/register/banners-catalog/main/index.jsx";
import MainRegisterWhatsApp from "./pages/register/whatsapp/main/index.jsx";
import WhatsAppSender from "./pages/whatsapp-sender/index.jsx";
import DashboardSDR from "./pages/report/whatsapp/dashboard/index.jsx";
import ReportsWhatsAppLeads from "./pages/report/whatsapp/report/index.jsx";
import InvoiceView from "./pages/billing/index.jsx";
import ProtectedLayout from "./routes/protectedLayout.jsx";
import ScrollToTop from "./routes/ScrollToTop.jsx";
import { PermissionUser } from "./middleware/permissionMiddleware.jsx";
import MainRegisterInstagram from "./pages/register/instagram/main/index.jsx";
import MainRegisterInstagramPosts from "./pages/register/instagram-posts/main/index.jsx";
import LoginInstagram from "./pages/auth/loginInstagram.jsx";
import AuthCallbackInstagram from "./pages/auth/authCallBackInstagram.jsx";
import AuthProcessFinally from "./pages/auth/authProcess.jsx";
import MainRegisterInstagramDM from "./pages/register/instagram-dm/main/index.jsx";
import InstaLeadLanding from "./pages/landing-instagram/index.jsx";
import ServiceMonitor from "./pages/server-status/index.jsx";
import SoldTypeClient from "./pages/report/client/sold-type-client/index.jsx";
import ReportRankingClientes from "./pages/report/client/ranking/index.jsx";

import WhatsAppSenderOfficial from "./pages/whatsapp-sender-official/index.jsx";
import WhatsAppSenderOfficialV2 from "./pages/whatsapp-sender-official-v2/index.jsx";
import InactiveClients from "./pages/report/client/inactive-clients/index.jsx";
import FechamentoCaixa from "./pages/report/caixa/fechamento-caixa.jsx";
import MainRegisterPromotions from "./pages/register/promotions/main/index.jsx";
import MainRegisterStoreLogo from "./pages/register/store-logo/main/index.jsx";
import MainRegisterStoreCatalog from "./pages/register/store-catalog/main/index.jsx";
import MainAdminCredenciais from "./pages/admin/credenciais/main/index.jsx";
import PoliticaDePrivacidade from "./pages/politica-de-privacidade/index.jsx";
import TermosDeUso from "./pages/termos-de-uso/index.jsx";
import ExclusaoDeDados from "./pages/exclusao-de-dados/index.jsx";

function Rotas() {
	return (
		<BrowserRouter>
			<ProviderGlobal>
				<ScrollToTop />
				<Routes>
					{/* PÚBLICAS */}
					<Route path="/instagram" element={<LoginInstagram />} />
					<Route path="/landing-instagram" element={<InstaLeadLanding />} />

					<Route path="/auth/instagram/callback" element={<AuthCallbackInstagram />} />

					<Route path="/login" element={<Login />} />
					<Route path="/recovery" element={<PasswordRecovery />} />
					<Route path="/forgot/:token" element={<Forgot />} />

					{/* Se /home, contratação, etc. são públicas, mantenha fora do bloco privado */}

					<Route path="/home" element={<Home />} />
					<Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
					<Route path="/termos-de-uso" element={<TermosDeUso />} />
					<Route path="/exclusao-de-dados" element={<ExclusaoDeDados />} />
					<Route path="/confirmation" element={<AuthProcessFinally />} />
					<Route path="/register-new-store/:id" element={<FormRegisterNewStore />} />
					<Route path="/download" element={<DownLoadDemo />} />

					{/* BLOCO PRIVADO (tudo que precisa estar logado) */}
					<Route element={<PrivateRoute />}>
						{/* LAYOUT ÚNICO COM SIDEBAR */}
						<Route element={<ProtectedLayout />}>
							{/* index = "/" */}
							<Route
								index
								element={
									<PermissionUser modulo="unattached1">
										<MainFinancas />
									</PermissionUser>
								}
							/>

							<Route
								path="dashboard-vendas"
								element={
									<PermissionUser modulo="relatorios">
										<DashBoardVendas />
									</PermissionUser>
								}
							/>
							<Route
								path="server/status"
								element={
									<PermissionUser modulo="unattached" empresa={1}>
										<ServiceMonitor />
									</PermissionUser>
								}
							/>
							<Route
								path="vendas-detalhamento"
								element={
									<PermissionUser modulo="relatorios">
										<RelatorioVendasDetalhamento />
									</PermissionUser>
								}
							/>

							{/* Financeiro */}
							<Route
								path="boleto-config"
								element={
									<PermissionUser modulo="boleto" app="BOLETO">
										<MainRegisterBoletoConfig />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal-config"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<MainRegisterFiscalConfig />
									</PermissionUser>
								}
							/>
							<Route
								path="boleto/remessa"
								element={
									<PermissionUser modulo="boleto" app="BOLETO">
										<MainRemessaBoleto />
									</PermissionUser>
								}
							/>
							<Route
								path="boleto/retorno"
								element={
									<PermissionUser modulo="boleto" app="BOLETO">
										<MainRetornoBoleto />
									</PermissionUser>
								}
							/>
							<Route
								path="conta-entrada"
								element={
									<PermissionUser modulo="cad_conta_entrada">
										<MainRegisterAccountEntry />
									</PermissionUser>
								}
							/>
							<Route
								path="conta-saida"
								element={
									<PermissionUser modulo="cad_conta_saida">
										<MainRegisterAccountOut />
									</PermissionUser>
								}
							/>
							<Route
								path="invoice-viewer"
								element={
									<PermissionUser modulo="unattached">
										<InvoiceView />
									</PermissionUser>
								}
							/>

							{/* Cadastros */}
							<Route
								path="register-product"
								element={
									<RegisterProductProvider>
										<PermissionUser modulo="cad_produto">
											<MainRegisterProduct />
										</PermissionUser>
									</RegisterProductProvider>
								}
							/>
							<Route
								path="register-complements"
								element={
									<PermissionUser modulo="cad_produto">
										<MainRegisterComplements />
									</PermissionUser>
								}
							/>
							<Route
								path="register-category"
								element={
									<PermissionUser modulo="cad_produto">
										<MainRegisterCategory />
									</PermissionUser>
								}
							/>
							<Route
								path="register-client"
								element={
									<RegisterClientProvider>
										<PermissionUser modulo="cad_cliente">
											<MainRegisterClient />
										</PermissionUser>
									</RegisterClientProvider>
								}
							/>
							<Route
								path="register-colaborador"
								element={
									<RegisterCollaboratorProvider>
										<PermissionUser modulo="cad_colaborador">
											<MainRegisterColaborador />
										</PermissionUser>
									</RegisterCollaboratorProvider>
								}
							/>
							<Route
								path="register-fornecedor"
								element={
									<RegisterSupplierProvider>
										<PermissionUser modulo="cad_fornecedor">
											<MainRegisterFornecedor />
										</PermissionUser>
									</RegisterSupplierProvider>
								}
							/>
							<Route
								path="register-store"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterStore />
									</PermissionUser>
								}
							/>
							<Route
								path="delivery-fee"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterDeliveryFee />
									</PermissionUser>
								}
							/>
							<Route
								path="store-hours"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterStoreHours />
									</PermissionUser>
								}
							/>
							<Route
								path="scheduled-pauses"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterScheduledPauses />
									</PermissionUser>
								}
							/>
							<Route
								path="forma-pagamento"
								element={
									<PermissionUser modulo="cad_financeiro">
										<MainRegisterFormPayment />
									</PermissionUser>
								}
							/>
							<Route
								path="register-cost-center"
								element={
									<PermissionUser modulo="cad_financeiro">
										<MainRegisterCostCenter />
									</PermissionUser>
								}
							/>
							<Route
								path="type-account"
								element={
									<PermissionUser modulo="cad_financeiro">
										<MainRegisterTypeAccount />
									</PermissionUser>
								}
							/>
							<Route
								path="client-type"
								element={
									<PermissionUser modulo="cad_cliente">
										<MainRegisterClientType />
									</PermissionUser>
								}
							/>
							<Route
								path="collaborator-type"
								element={
									<PermissionUser modulo="cad_colaborador">
										<MainRegisterCollaboratorType />
									</PermissionUser>
								}
							/>
							<Route
								path="bank"
								element={
									<PermissionUser modulo="cad_financeiro">
										<MainRegisterBank />
									</PermissionUser>
								}
							/>
							<Route
								path="register-promotions"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterPromotions />
									</PermissionUser>
								}
							/>
							<Route
								path="store-logo"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterStoreLogo />
									</PermissionUser>
								}
							/>
							<Route
								path="store-catalog"
								element={
									<PermissionUser modulo="cad_empresa">
										<MainRegisterStoreCatalog />
									</PermissionUser>
								}
							/>
							<Route path="register-complements" element={<MainRegisterComplements />} />

							<Route
								path="instagram-register"
								element={
									<PermissionUser modulo="marketing">
										<MainRegisterInstagram />
									</PermissionUser>
								}
							/>

							<Route
								path="instagram-posts"
								element={
									<PermissionUser modulo="marketing">
										<MainRegisterInstagramPosts />
									</PermissionUser>
								}
							/>

							<Route
								path="instagram-dm"
								element={
									<PermissionUser modulo="marketing">
										<MainRegisterInstagramDM />
									</PermissionUser>
								}
							/>

							{/* WhatsApp / Marketing */}
							<Route
								path="whatsapp-connect"
								element={
									// <PermissionUser modulo="marketing">
									<MainRegisterWhatsApp />
									// </PermissionUser>
								}
							/>

							<Route
								path="whatsapp-sender"
								element={
									// <PermissionUser modulo="marketing">
									<WhatsAppSender />
									// </PermissionUser>
								}
							/>
							<Route
								path="whatsapp-oficial"
								element={
									// <PermissionUser modulo="marketing">
									<WhatsAppSenderOfficial />
									// </PermissionUser>
								}
							/>
							<Route
								path="whatsapp-oficial-v2"
								element={
									// <PermissionUser modulo="marketing">
									<WhatsAppSenderOfficialV2 />
									// </PermissionUser>
								}
							/>
							<Route
								path="whatsapp-dashboard"
								element={
									<PermissionUser modulo="marketing">
										<DashboardSDR />
									</PermissionUser>
								}
							/>
							<Route
								path="register-banners"
								element={
									<PermissionUser modulo="cad_produto">
										<MainRegisterBanner />
									</PermissionUser>
								}
							/>

							{/* Relatórios */}
							<Route
								path="alterar-venda/:id"
								element={
									<PermissionUser modulo="cad_conta_entrada">
										<AlterarVendaContainer />
									</PermissionUser>
								}
							/>
							<Route
								path="movimentacao"
								element={
									<PermissionUser modulo="mov_caixa">
										<FechamentoCaixa />
									</PermissionUser>
								}
							/>
							<Route
								path="movimentacao-financeira"
								element={
									<PermissionUser modulo="mov_caixa">
										<MovimentacaoCaixaAnalitico />
									</PermissionUser>
								}
							/>
							<Route
								path="vendas-colaborador"
								element={
									<PermissionUser modulo="relatorios">
										<ReportSaleBySeller />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos-deletados"
								element={
									<PermissionUser modulo="relatorios">
										<ProdutosDeletados />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/curva-abc"
								element={
									<PermissionUser modulo="relatorios">
										<ReportCurvaABC />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/estoque-baixo"
								element={
									<PermissionUser modulo="relatorios">
										<ReportEstoqueBaixo />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/vendas/estoque"
								element={
									<PermissionUser modulo="relatorios">
										<ReportsProductsSoldAndInventory />
									</PermissionUser>
								}
							/>
							<Route
								path="reports/leads/whatsapp"
								element={
									<PermissionUser modulo="marketing">
										<ReportsWhatsAppLeads />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/item-faturamento"
								element={
									<PermissionUser modulo="relatorios">
										<ReportItemFaturamento />
									</PermissionUser>
								}
							/>
							<Route
								path="vendas/listagem"
								element={
									<PermissionUser modulo="relatorios">
										<ReportListagemVendas />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal/listagem"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<ReportNotaFiscal />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal/monitor"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<MonitorFiscal />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal/fechamento"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<FechamentoFiscal />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal/documentos"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<DocumentosFiscais />
									</PermissionUser>
								}
							/>
							<Route
								path="fiscal/sefaz"
								element={
									<PermissionUser modulo="fiscal" app="EMISSOR FISCAL">
										<NotasSefaz />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/grade-vendidos"
								element={
									<PermissionUser modulo="relatorios">
										<ReportGradeVendidos />
									</PermissionUser>
								}
							/>
							<Route
								path="produtos/estoque-baixo-grade"
								element={
									<PermissionUser modulo="relatorios">
										<ReportEstoqueBaixoGrade />
									</PermissionUser>
								}
							/>
							<Route
								path="dashboard-receitas-e-despesas"
								element={
									<PermissionUser modulo="relatorios">
										<DashBoard />
									</PermissionUser>
								}
							/>
							<Route
								path="cliente/vendas/tipo"
								element={
									<PermissionUser modulo="relatorios">
										<SoldTypeClient />
									</PermissionUser>
								}
							/>
							<Route
								path="cliente/ranking"
								element={
									<PermissionUser modulo="relatorios">
										<ReportRankingClientes />
									</PermissionUser>
								}
							/>
							<Route
								path="cliente/inativos"
								element={
									<PermissionUser modulo="relatorios">
										<InactiveClients />
									</PermissionUser>
								}
							/>

							{/* Se vídeos forem privados, deixe aqui; se forem públicos, mantenha fora */}
							{/* <Route path="videos" element={<ModulosVideos />} />
              <Route path="videos/:id" element={<Videos />} /> */}
							{/* Admin — visível apenas para empresa 1 (SZ Sistemas) */}
							<Route
								path="admin/credenciais"
								element={
									<PermissionUser modulo="unattached" empresa={1}>
										<MainAdminCredenciais />
									</PermissionUser>
								}
							/>

						</Route>
					</Route>

					{/* VÍDEOS PÚBLICOS (se quiser manter público e COM sidebar, crie um PublicLayout similar) */}
					<Route path="/videos" element={<ModulosVideos />} />
					<Route path="/videos/:id" element={<Videos />} />

					{/* Outros */}
					<Route path="/teste" element={<Teste />} />
					{/* 404 opcional */}
					{/* <Route path="*" element={<NotFound />} /> */}
				</Routes>
			</ProviderGlobal>
		</BrowserRouter>
	);
}

export default Rotas;

// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "./pages/home/index.jsx";
// import Login from "./pages/login/index.jsx";
// import PrivateRoute from "./services/private.jsx";
// import DashBoard from "./pages/dashboard/receive-payments/index.jsx";
// import Videos from "./pages/youtube/index.jsx";
// import SideBar from "./components/sidebar/index.jsx";
// import MainFinancas from "./pages/main-financas/main-financas.jsx";
// import DashBoardVendas from "./pages/dashboard/Vendas/index.jsx";
// import MovimentacaoCaixa from "./pages/movimentacao/movimentacao/index.jsx";
// import ProdutosDeletados from "./pages/movimentacao/deletados/index.jsx";
// import ListContaEntradaSZ from "./components/table/ce/indexSZ.jsx";
// import ModulosVideos from "./pages/youtube/modulos/index.jsx";
// import Teste from "./pages/teste/teste.jsx";
// import { RegisterClientProvider } from "./components/register/register-cliente/context/index.jsx";
// import { MainRegisterClient } from "./pages/register/register-cliente/index.jsx";
// import { ProviderGlobal } from "./context/index.jsx";
// import { MainRegisterColaborador } from "./pages/register/register-colaborador/index.jsx";
// import { RegisterCollaboratorProvider } from "./components/register/register-colaborador/context/index.jsx";
// import { RegisterSupplierProvider } from "./components/register/register-fornecedor/context/index.jsx";
// import { MainRegisterFornecedor } from "./pages/register/register-fornecedor/index.jsx";
// import ReportSaleBySeller from "./pages/dashboard/vendas-colaborador/index.jsx";
// import { RegisterProductProvider } from "./pages/register/product/context/index.jsx";
// import MainRegisterProduct from "./pages/register/product/main/index.jsx";
// import MainRegisterComplements from "./pages/register/complements/main/index.jsx";
// import MainRegisterStore from "./pages/register/store/main/index.jsx";
// import MainRegisterFormPayment from "./pages/register/form-payment/main/index.jsx";
// import FormRegisterNewStore from "./pages/contratacao/register-contracting-start/index.jsx";
// import DownLoadDemo from "./pages/contratacao/downloads/pdv/index.jsx";
// import MainRegisterCostCenter from "./pages/register/cost-center/main/index.jsx";
// import MainRegisterTypeAccount from "./pages/register/type-account/main/index.jsx";
// import MainRegisterClientType from "./pages/register/client-type/main/index.jsx";
// import MainRegisterCollaboratorType from "./pages/register/collaborator-type/main/index.jsx";
// import MainRegisterBank from "./pages/register/bank/main/index.jsx";
// import MainRegisterCategory from "./pages/register/product-category/main/index.jsx";
// import ReportCurvaABC from "./pages/report/product/abc/index.jsx";
// import ReportItemFaturamento from "./pages/report/venda-item/venda-faturamento.jsx";
// import ReportsProductsSoldAndInventory from "./pages/report/product/vendas-estoque/index.jsx";
// import SoldTypeClient from "./pages/report/client/sold-type-client/index.jsx";
// import MainRegisterAccountOut from "./pages/register/account-out/main/index.jsx";
// import MainRegisterAccountEntry from "./pages/register/account-entry/main/index.jsx";
// import { PermissionUser } from "./middleware/permissionMiddleware.jsx";
// import PasswordRecovery from "./components/login/recovery/index.jsx";
// import Forgot from "./components/login/forgot/index.jsx";
// import MainRegisterBanners from "./pages/register/banners/main/index.jsx";
// import MainRegisterBanner from "./pages/register/banners-catalog/main/index.jsx";
// import MainRegisterWhatsApp from "./pages/register/whatsapp/main/index.jsx";
// import WhatsAppSender from "./pages/whatsapp-sender/index.jsx";
// import DashboardSDR from "./pages/report/whatsapp/dashboard/index.jsx";
// import ReportsWhatsAppLeads from "./pages/report/whatsapp/report/index.jsx";
// import InvoiceView from "./pages/billing/index.jsx";

// function Rotas() {
// 	return (
// 		<BrowserRouter>
// 			<ProviderGlobal>
// 				<Routes>
// 					<Route path="/login" element={<Login />} />
// 					<Route path="/recovery" element={<PasswordRecovery />} />
// 					<Route path="/forgot/:token" element={<Forgot />} />

// 					<Route
// 						// path="/admin"
// 						path="/"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<MainFinancas />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/dashboard-vendas"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<DashBoardVendas />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					{/* remover ListContaEntrada */}
// 					<Route
// 						path="/conta-entrada"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_conta_entrada">
// 											<MainRegisterAccountEntry />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterAccountEntry />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/invoice-viewer"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<InvoiceView />} />
// 								{/* <SideBar render={<MainRegisterAccountOut />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/conta-saida"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_conta_saida">
// 											<MainRegisterAccountOut />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterAccountOut />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					{/* <Route
// 						path="/conta-entrada"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ListContaEntradaSZ />} />
// 							</PrivateRoute>
// 						}
// 					/> */}

// 					{/* Formularios de cadastro */}
// 					{/* <Route
// 						path="/produto-cadastro"
// 						element={
// 							<PrivateRoute>
// 								<RegisterProductProvider>
// 									<SideBar render={<MainRegisterProduct />} />
// 								</RegisterProductProvider>
// 							</PrivateRoute>
// 						}
// 					/> */}
// 					<Route
// 						path="/register-product"
// 						element={
// 							<PrivateRoute>
// 								<RegisterProductProvider>
// 									<SideBar
// 										render={
// 											<PermissionUser modulo="cad_produto">
// 												<MainRegisterProduct />
// 											</PermissionUser>
// 										}
// 									/>
// 									{/* <SideBar render={<MainRegisterProduct />} /> */}
// 								</RegisterProductProvider>
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/whatsapp-sender"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_produto">
// 											<WhatsAppSender />
// 										</PermissionUser>
// 									}
// 								/>
// 							</PrivateRoute>
// 						}
// 					/>

// 					<Route
// 						path="/whatsapp-connect"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_produto">
// 											<MainRegisterWhatsApp />
// 										</PermissionUser>
// 									}
// 								/>
// 							</PrivateRoute>
// 						}
// 					/>

// 					<Route
// 						path="/whatsapp-dashboard"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_produto">
// 											<DashboardSDR />
// 										</PermissionUser>
// 									}
// 								/>
// 							</PrivateRoute>
// 						}
// 					/>

// 					<Route
// 						path="/register-banners"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_produto">
// 											<MainRegisterBanner />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterStore />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-cost-center"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_financeiro">
// 											<MainRegisterCostCenter />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterCostCenter />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/type-account"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_financeiro">
// 											<MainRegisterTypeAccount />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterTypeAccount />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/client-type"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_cliente">
// 											<MainRegisterClientType />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterClientType />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/collaborator-type"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_colaborador">
// 											<MainRegisterCollaboratorType />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterCollaboratorType />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/bank"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_financeiro">
// 											<MainRegisterBank />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterBank />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-complements"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<MainRegisterComplements />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-category"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_produto">
// 											<MainRegisterCategory />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <RegisterCategoryProvider> */}
// 								{/* <SideBar render={<MainRegisterCategory />} /> */}
// 								{/* </RegisterCategoryProvider> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-client"
// 						element={
// 							<PrivateRoute>
// 								<RegisterClientProvider>
// 									<SideBar
// 										render={
// 											<PermissionUser modulo="cad_cliente">
// 												<MainRegisterClient />
// 											</PermissionUser>
// 										}
// 									/>
// 									{/* <SideBar render={<MainRegisterClient />} /> */}
// 								</RegisterClientProvider>
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-colaborador"
// 						element={
// 							<PrivateRoute>
// 								<RegisterCollaboratorProvider>
// 									<SideBar
// 										render={
// 											<PermissionUser modulo="cad_colaborador">
// 												<MainRegisterColaborador />
// 											</PermissionUser>
// 										}
// 									/>
// 									{/* <SideBar render={<MainRegisterColaborador />} /> */}
// 								</RegisterCollaboratorProvider>
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-store"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_empresa">
// 											<MainRegisterStore />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterStore />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>

// 					<Route
// 						path="/forma-pagamento"
// 						element={
// 							<PrivateRoute>
// 								<SideBar
// 									render={
// 										<PermissionUser modulo="cad_financeiro">
// 											<MainRegisterFormPayment />
// 										</PermissionUser>
// 									}
// 								/>
// 								{/* <SideBar render={<MainRegisterFormPayment />} /> */}
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/register-fornecedor"
// 						element={
// 							<PrivateRoute>
// 								<RegisterSupplierProvider>
// 									<SideBar
// 										render={
// 											<PermissionUser modulo="cad_fornecedor">
// 												<MainRegisterFornecedor />
// 											</PermissionUser>
// 										}
// 									/>
// 									{/* <SideBar render={<MainRegisterFornecedor />} /> */}
// 								</RegisterSupplierProvider>
// 							</PrivateRoute>
// 						}
// 					/>
// 					{/* Fim Formularios de cadastro */}
// 					{/* <Route
// 						path="/cliente"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<Cliente />} />
// 							</PrivateRoute>
// 						}
// 					/> */}

// 					<Route
// 						path="/cliente/vendas/tipo"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<SoldTypeClient />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/movimentacao"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<MovimentacaoCaixa />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/vendas-colaborador"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ReportSaleBySeller />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					{/* <Route
// 						path="/conta-saida"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ContaSaida />} />
// 							</PrivateRoute>
// 						}
// 					/> */}
// 					<Route
// 						path="/produtos-deletados"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ProdutosDeletados />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/produtos/curva-abc"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ReportCurvaABC />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/produtos/vendas/estoque"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ReportsProductsSoldAndInventory />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/reports/leads/whatsapp"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ReportsWhatsAppLeads />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route
// 						path="/produtos/item-faturamento"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<ReportItemFaturamento />} />
// 							</PrivateRoute>
// 						}
// 					/>

// 					<Route
// 						path="/dashboard-receitas-e-despesas"
// 						element={
// 							<PrivateRoute>
// 								<SideBar render={<DashBoard />} />
// 							</PrivateRoute>
// 						}
// 					/>
// 					<Route path="/videos" element={<SideBar render={<ModulosVideos />} />} />
// 					<Route path="/videos/:id" element={<SideBar render={<Videos />} />} />
// 					{/* <Route path="/videos/:id" element={<Videos />} /> */}
// 					{/* <Route path="/videos" element={<ModulosVideos />} /> */}
// 					<Route path="/teste" element={<Teste />} />
// 					{/*<Route path="/cadastro " element={<Usuario />} />

// 				<Route path="/sidebar" element={<Sidebar />} />
// 				<Route path="/js" element={<Js />} /> */}
// 					{/* Rotas contratação do software */}
// 					<Route path="/home" element={<Home />} />
// 					<Route path="/register-new-store/:id" element={<FormRegisterNewStore />} />
// 					<Route path="/download" element={<DownLoadDemo />} />
// 					{/* Fim rotas contratação do software */}
// 				</Routes>
// 			</ProviderGlobal>
// 		</BrowserRouter>
// 	);
// }

// export default Rotas;
